export const API_REQUEST = 'API_REQUEST'
export const API_ERROR = 'API_ERROR'
export const AUTH_ERROR = 'AUTH_ERROR'
export const MALFORMED_ERROR = 'MALFORMED_ERROR'
export const ERROR_MESSAGE = 'ERROR_MESSAGE'
export const SUCCESS_MESSAGE = 'SUCCESS_MESSAGE'
export const FILE_UPLOAD_ERROR = 'FILE_UPLOAD_ERROR'
